
import * as React from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';

export default function BasicPopover({
  length,
  children,
  className = "",
  customTrigger = null,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'click-popover' : undefined;

  return (
    <>
      {customTrigger ? (
        React.cloneElement(customTrigger, {
          'aria-owns': open ? id : undefined,
          'aria-haspopup': true,
          onClick: handleClick,
        })
      ) : (
        <Button
          aria-owns={open ? id : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          className={`p-0 popover-btn ${className}`}
          size="small"
          variant="outlined"
          sx={{ minWidth: '35px' }}
        >
          + {length}
        </Button>
      )}

      {children && (
        <Popover
          className='popover-wrapper'
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        
        
        >
          <Box className="popover-wrapper-box">
            {children}
          </Box>
        </Popover>
      )}
    </>
  );
}

